// Preset curated-audio categories (admins may also type a custom one).
export const AUDIO_CATEGORIES = [
  "Navratri",
  "Deities",
  "Festivals",
  "Occasions",
  "Morning Playlist",
  "Evening Playlist",
  "Nama Japa",
  "Vrata Kathas",
  "Pravachan",
  "Mantras",
  "Stotras",
  "Bhajans",
];
